import React, { useRef, useState } from "react";
import Modal from "react-modal";
import _isEqual from "lodash.isequal";
import Select from "../../../shared/Select";
import Toggle from "../../../shared/Toggle";
import ValidatedInput from "../../../shared/ValidatedInput";
import { EnumType } from "../../../../services/resources/SystemApi";

interface CustomQuestion {
  isActive: boolean;
  isMandatory: boolean;
  questionText: string;
  responseType: string;
}

interface Props {
  close: () => void;
  save: (question: CustomQuestion) => void;
  questionToEdit?: CustomQuestion;
  customQuestionResponseTypes: EnumType[];
}

export default function CustomQuestionModal({
  close,
  save,
  questionToEdit,
  customQuestionResponseTypes,
}: Props) {
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [question, setQuestion] = useState<CustomQuestion>(
    questionToEdit || {
      isActive: true,
      isMandatory: false,
      questionText: "",
      responseType: "",
    }
  );
  const initialState = useRef(question);

  const onChangeQuestion = (name, value) => {
    setQuestion({
      ...question,
      [name]: value,
    });
  };

  const onSave = () => {
    setSubmitAttempted(true);
    if (!question.questionText || !question.responseType) {
      return;
    }
    save(question);
    close();
  };

  return (
    <Modal isOpen={true} className="modal-container program-settings-page">
      <div className="modal-card card new-custom-questions-modal">
        <p className="large-text fw-500 mb-16">
          {!questionToEdit ? "New" : "Edit"} Question
        </p>
        <div className="flex flex-align-center">
          <label
            className="accent-text-dark"
            style={{ width: "96px", minWidth: "96px" }}
          >
            Type
          </label>
          <ValidatedInput
            input={
              <Select
                options={
                  customQuestionResponseTypes?.map((rt) => ({
                    display: rt.displayValue,
                    value: rt.enumValue,
                  })) || []
                }
              />
            }
            name="responseType"
            onChange={onChangeQuestion}
            required={true}
            showRequired={submitAttempted}
            value={question.responseType}
          />
        </div>

        <div className="flex flex-align-center">
          <Toggle
            name="isMandatory"
            onChange={() => {
              onChangeQuestion("isMandatory", !question.isMandatory);
            }}
            options={[
              {
                value: true,
                display: "Mandatory",
              },
              {
                value: false,
                display: "Optional",
              },
            ]}
            value={question.isMandatory}
          />
        </div>

        <div>
          <p className="fw-700">Question Text</p>
          <ValidatedInput
            input={<textarea placeholder="Type question text here..." />}
            name="questionText"
            onChange={(e) => onChangeQuestion(e.target.name, e.target.value)}
            required={true}
            showRequired={submitAttempted}
            value={question.questionText}
          />
        </div>
        <div className="modal-btns flex flex-align-center flex-justify-end mt-16">
          <button
            className="btn link-text uppercase-text fw-500"
            onClick={close}
          >
            Cancel
          </button>
          <button
            className="btn link-text uppercase-text fw-500 ml-24"
            disabled={_isEqual(initialState.current, question)}
            onClick={onSave}
          >
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
}
